export default{sources:{avif:"__VITE_ASSET__7MojDZtt__ 32w",webp:"__VITE_ASSET__DxgxedIl__ 32w"},img:{src:"__VITE_ASSET__CmaSfhdE__",w:32,h:32}};